import axios from '@/assets/http';

export default {
    getConfig(params) {
        return axios.get(`/api/index/getConfig`, {params: params});
    },
    getArticle(params) {
        return axios.get(`/api/index/getArticle`, {params: params});
    },
}
